import { render } from "./AppLarens.vue?vue&type=template&id=54d9abc6&scoped=true"
import script from "./AppLarens.vue?vue&type=script&lang=js"
export * from "./AppLarens.vue?vue&type=script&lang=js"

import "./AppLarens.vue?vue&type=style&index=0&id=54d9abc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\petr.hric\\Desktop\\MyDrive\\web\\mkosmeo\\mkosmeo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d9abc6"]])

export default __exports__